
import { generateVO2MaxReportHTML } from './vo2MaxReportService';

export const generateReportHTML = async (reportData, reportType = 'dexa') => {
  // If this is a VO2Max report, use the dedicated service
  if (reportType === 'vo2max') {
    return generateVO2MaxReportHTML(reportData);
  }
  
  // Otherwise, continue with DEXA report generation
  try {
    console.log("reportData", reportData);
    // Fetch the template file
    const response = await fetch('/templates/dexa_report.html');
    // remove page space
    if (!response.ok) {
      throw new Error(`Failed to fetch template: ${response.status}`);
    }
    let template = await response.text();
    // Replace all placeholders with actual data
    // Helper function to format date as "2ND APRIL 2025"
    function formatDate(dateString) {
        if (!dateString || dateString.trim() === '' || isNaN(Date.parse(dateString))) {
            return 'N/A';
        }
        
        const date = new Date(dateString);
        if (isNaN(date.getTime())) {
            return 'N/A';
        }
        
        const day = date.getDate();
        const month = date.toLocaleString('en-US', { month: 'short' }).toUpperCase();
        const year = date.getFullYear();
        
        // Add suffix to day (1st, 2nd, 3rd, etc.)
        const suffix = getDaySuffix(day);
        
        // return `${day}${suffix} ${month} ${year}`;
        return `${day} ${month} ${year}`;
    }

    // Helper function to get the day suffix
    function getDaySuffix(day) {
        if (day >= 11 && day <= 13) return 'TH';
        switch (day % 10) {
            case 1: return 'ST';
            case 2: return 'ND';
            case 3: return 'RD';
            default: return 'TH';
        }
    }




    function getVisceralFatStatusClass(vfa_status) {
      switch (vfa_status) {
          case 0: return 'green';
          case 1: return 'red';
          default: return 'green'; // default to green if status is invalid
      }
  }

  function getVisceralFatStatusTitle(vfa_status) {
    switch (vfa_status) {
        case 0: return 'Your visceral fat area is healthy';
        case 1: return 'Your visceral fat area is high';
        default: return 'Your visceral fat area is healthy'; // default to green if status is invalid
    }
}



function getAGRadioClass(vfa_status) {
  switch (vfa_status) {
      case 0: return 'green';
      case 1: return 'green';
      case 2: return 'yellow';
      default: return 'green'; // default to green if status is invalid
  }
}

function getAGRadioStatusTitle(vfa_status) {
switch (vfa_status) {
    case 0: return 'Your A/G ratio is optimal';
    case 1: return 'Your A/G ratio is optimal';
    case 2: return 'Your A/G ratio is suboptimal';
    default: return 'Your A/G ratio is optimal'; // default to green if status is invalid
}
}



function getasymmetryStatusTitle(asymmetry_status) {
  switch (asymmetry_status) {
      case 0: return 'You have no asymmetry';
      case 1: return 'You have moderate asymmetry';
      case 2: return 'You have large asymmetry';
      default: return 'You have no asymmetry'; // default to green if status is invalid
  }
}

function getasymmetryStatusClass(asymmetry_status) {
  switch (asymmetry_status) {
      case 0: return 'green';
      case 1: return 'yellow';
      case 2: return 'red';
      default: return 'green'; // default to green if status is invalid
  }
  }


function getasymmetryDescription(asymmetry_status) {
  switch (asymmetry_status) {
      case 0: return 'Your muscle distribution is symmetrical, which supports efficient movement and reduces injury risk. This is the ideal zone for long-term performance and joint health.';
      case 1: return 'There’s a moderate difference between sides — often due to limb dominance, past injuries, or training bias. While not alarming, it’s something to be aware of, especially if you’re focused on performance or longevity.';
      case 2: return 'A large muscle mass difference between limbs may lead to movement compensations, joint stress, or injury over time. It’s often seen after injury, surgery, or chronic overuse of one side.';
      default: return 'Your muscle distribution is symmetrical, which supports efficient movement and reduces injury risk. This is the ideal zone for long-term performance and joint health.'; // default to green if status is invalid
  }
  }
  
    // Helper function to get summary block class based on fat_status
    function getFatStatusClass(fatStatus) {
      switch (fatStatus) {
          case 0: return 'red';
          case 1: return 'green';
          case 2: return 'red';
          default: return 'green'; // default to green if status is invalid
      }
  }

    // Helper function to get summary block class based on fat_status
    function getFatStatusRisk(fatStatus) {
      switch (fatStatus) {
        case 0: return 'Low';
        case 1: return 'High';
        case 2: return 'High';
        case 3: return 'High';
          default: return 'Low'; // default to green if status is invalid
      }
  }

  function getFatRiskStatus(fatStatus) {
    switch (fatStatus) {
      case 0: return 'green';
      case 1: return 'red';
      case 2: return 'red';
      case 3: return 'red';
        default: return 'green'; // default to green if status is invalid
    }
}



//  0 is "Under Nourished"
    //  1 is "Adequately Nourished" 
    //  2 is "Over Nourished"

    function getFatStatusTitle(fatStatus) {
      switch (fatStatus) {
          case 0: return 'Under Nourished';
          case 1: return 'Adequately Nourished';
          case 2: return 'Over Nourished';
          default: return 'Adequately Nourished'; // default to green if status is invalid
      }
  }

  function getFatStatusDescription(age,gender,fatStatus, bodyFatRangeMiddle, bodyFatRangeMiddle2) {
    switch (fatStatus) {
        case 0: return 'For a '+age+'-year-old '+gender.toLowerCase()+', your body fat is below the range of ' + bodyFatRangeMiddle + '% – ' + bodyFatRangeMiddle2 + '%, this may impact hormone balance, energy levels, and recovery. Supporting essential fat stores can help improve long-term function';
        case 1: return 'For a '+age+'-year-old '+gender.toLowerCase()+', your body fat is within the range of ' + bodyFatRangeMiddle + '% – ' + bodyFatRangeMiddle2 + '%, enough to support hormones and energy, without excess metabolic load';
        case 2: return 'For a '+age+'-year-old '+gender.toLowerCase()+', your body fat is above the range of ' + bodyFatRangeMiddle + '% – ' + bodyFatRangeMiddle2 + '%, this can increase metabolic stress and impact energy, hormones, and recovery. Gradual fat loss may help improve overall health and performance.';
        default: return 'For a '+age+'-year-old '+gender.toLowerCase()+', your body fat is within the range of ' + bodyFatRangeMiddle + '% – ' + bodyFatRangeMiddle2 + '%, enough to support hormones and energy, without excess metabolic load'; // default to green if status is invalid
    }
}


  function getFatStatusPage3Title(fatStatus) {
    switch (fatStatus) {
        case 1: return 'your body fat percentage is healthy';
        case 0: return 'Your body fat percentage is unhealthy';
        case 2: return 'Your body fat percentage is unhealthy';
        default: return 'Your body fat percentage is healthy'; // default to green if status is invalid
    }
}

function getFatStatusPage3Description(fatStatus) {
  switch (fatStatus) {
      case 2: return 'Your body fat percentage is above the healthy reference range. While fat is essential for function, excess can increase the risk of insulin resistance, fatigue, and systemic inflammation. Fat loss through strength and endurance training is recommended.';
      case 1: return 'Your body fat percentage is within the healthy reference range for your age and sex. This supports optimal energy balance, hormone production, and physical performance.';
      case 0: return 'Your body fat is below the reference range. While this may support leanness, it could compromise hormonal health, recovery, and energy levels if sustained long-term. Consider gradually increasing calorie intake and recovery focus.';
      default: return 'Your body fat percentage is within the healthy reference range for your age and sex. This supports optimal energy balance, hormone production, and physical performance.'; // default to green if status is invalid
  }
}

function getNutritionSuggestions(body_composition_zone_nutrition_suggestion) {
  let resValue =""
  if(body_composition_zone_nutrition_suggestion){
    let val = body_composition_zone_nutrition_suggestion.split('\n\n');
    val.forEach((item) => {
      resValue += `<li>${item}</li>`;
    });
    return resValue;
  }
  return [
        'Calorie Surplus - Increase overall calorie intake with nutrient dense food like whole grains, healthy fats (nuts, seeds, olive oil, avocados) and lean protein sources (Yoghurt, eggs, beans, fish, chicken, whey protein)',
        'At Least 1 - 1.5g of protein per kg of body weight - Fish, Egg Whites, Beans, Nuts, Whey Protein'
    ];
}

// - No Risk - ALMI > 8 for male and > 6.5 for female
// - Low risk - ALMI 7.5 to 8 for male and 6 to 6.5 for female
// - Moderate risk -  ALMI 7 to 7.5 for male and 5.5 to 6 for female
// - High risk -  ALMI <7 for male and <5.5 for female
function getMuscleStatusRisk(almiNumber, gender) {
  if((gender.toLowerCase().substring(0, 1) === 'm' && parseFloat(almiNumber) > 8) || (gender.toLowerCase().substring(0, 1) === 'f' && parseFloat(almiNumber) > 6.5)){
    return 'Low';
  }
  else if((gender.toLowerCase().substring(0, 1) === 'm' && parseFloat(almiNumber) > 7.5) || (gender.toLowerCase().substring(0, 1) === 'f' && parseFloat(almiNumber) > 6)){
    return 'Low';
  }
  else if((gender.toLowerCase().substring(0, 1) === 'm' && parseFloat(almiNumber) > 7) || (gender.toLowerCase().substring(0, 1) === 'f' && parseFloat(almiNumber) > 5.5)){
    return 'Low';
  }
  else{
    return 'High';
  }
}

function getMuscleStatusRiskClass(almiNumber, gender) {
  if((gender.toLowerCase().substring(0, 1) === 'm' && parseFloat(almiNumber) > 8) || (gender.toLowerCase().substring(0, 1) === 'f' && parseFloat(almiNumber) > 6.5)){
    return 'green';
  }
  else if((gender.toLowerCase().substring(0, 1) === 'm' && parseFloat(almiNumber) > 7.5) || (gender.toLowerCase().substring(0, 1) === 'f' && parseFloat(almiNumber) > 6)){
    return 'green';
  }
  else if((gender.toLowerCase().substring(0, 1) === 'm' && parseFloat(almiNumber) > 7) || (gender.toLowerCase().substring(0, 1) === 'f' && parseFloat(almiNumber) > 5.5)){
    return 'green';
  }
  else{
    return 'red';
  }
}



    // Helper function to get muscle status class based on ALMI and gender
    function getMuscleStatusClass(almiNumber, gender) {
        const threshold = gender.toLowerCase().substring(0, 1) === 'm' ? 7.0 : 5.5;
        return parseFloat(almiNumber) < threshold ? 'red' : 'green';
    }

    // Helper function to get muscle status message based on ALMI and gender
    function getMuscleStatusMessage(almiNumber, gender) {
      const threshold = gender.toLowerCase().substring(0, 1) === 'm' ? 7.0 : 5.5;
      return parseFloat(almiNumber) < threshold ? 'Under muscled' : 'Adequately muscled';
  }
  function getMuscleStatusDescription(almiNumber, gender) {
    const threshold = gender.toLowerCase().substring(0, 1) === 'm' ? 7.0 : 5.5;
    return parseFloat(almiNumber) < threshold ? `(Your ALMI is below ${threshold} — an indicator of low skeletal muscle health and physical resilience.)` : `(Your ALMI is above ${threshold} — an indicator of adequate skeletal muscle health and physical resilience.)`;
  }

    
    // Helper function to split string into lines
    function splitStringIntoLines(str) {
        return str.split('\n').filter(line => line.trim());
    }

    function getBoneDensityStatusRisk(fractureRisk) {
      switch (fractureRisk) {
          case 0: return 'Low';
          case 1: return 'Medium';
          case 2: return 'High';
          default: return 'Low'; // default to yellow if status is invalid
      }
  }

    // Helper function to get bone density status class based on fracture_risk
    function getBoneDensityStatusClass(fractureRisk) {
        switch (fractureRisk) {
            case 0: return 'green';
            case 1: return 'yellow';
            case 2: return 'red';
            default: return 'yellow'; // default to yellow if status is invalid
        }
    }

    function getOverallRiskFactorTitle(status) {
      switch (status) {
        case 'red': return 'High';
        case 'yellow': return 'Medium';
        case 'green': return 'Low';
        default: return 'Low'; // default to green if status is invalid
      }
    }
    // Helper function to determine overall risk factor
    function getOverallRiskFactor(muscleStatus, fatStatus, boneStatus) {
        // If any status is red, return red
        if (muscleStatus === 'red' || fatStatus === 'red' || boneStatus === 'red') {
            return 'red';
        }
        // If any status is yellow, return yellow
        if (muscleStatus === 'yellow' || fatStatus === 'yellow' || boneStatus === 'yellow') {
            return 'yellow';
        }
        // Otherwise return green
        return 'green';
    }

    function getBoneDensityStatusTitle(fractureRisk) {
      switch (fractureRisk) {
          case 0: return 'Your bones are strong';
          case 1: return 'Your bones are becoming weak';
          case 2: return 'Your bones are fragile';
          default: return 'Your bones are strong'; // default to yellow if status is invalid
      }
  }

  function getBoneDensityStatusDescription(fractureRisk) {
    switch (fractureRisk) {
        case 0: return 'Your bones are well-mineralised and structurally solid — above the threshold for concern.';
        case 1: return 'Your bone density is lower than ideal, indicating a reduction in mineral strength compared to peak levels. While not in the osteoporosis range, this result signals the need for increased attention to bone health and structural resilience over time.';
        case 2: return 'A T-score in this range means your bones have become significantly weaker. Fracture risk is high, especially in the spine, hip, and wrist. You’ll benefit from a guided care plan that includes strength training, medical guidance, nutrition, and possibly medication. Early action here protects independence and longevity.';
        default: return 'Your bones are well-mineralised and structurally solid — above the threshold for concern.'; // default to yellow if status is invalid
    }
}

const bodyFatPercentiles = {
  male: [
    { ageMin: 14, ageMax: 29, percentiles: [11.0, 14.0, 16.5, 18.5, 20.2, 22.7, 25.6, 28.7, 31.8] },
    { ageMin: 30, ageMax: 39, percentiles: [11.2, 17.2, 19.2, 23.3, 26.4, 30.2, 33.7, 36.6, 39.9] },
    { ageMin: 40, ageMax: 49, percentiles: [15.8, 22.2, 25.8, 28.4, 30.1, 31.5, 33.9, 36.9, 41.0] },
    { ageMin: 50, ageMax: 59, percentiles: [20.0, 24.1, 26.8, 29.4, 31.4, 33.7, 35.7, 37.9, 40.8] },
    { ageMin: 60, ageMax: 69, percentiles: [21.0, 25.1, 27.3, 29.4, 31.6, 33.5, 34.7, 37.2, 40.7] },
    { ageMin: 70, ageMax: 100, percentiles: [23.0, 25.7, 28.0, 29.4, 32.4, 34.0, 35.7, 37.4, 39.6] }
  ],
  female: [
    { ageMin: 14, ageMax: 29, percentiles: [22.1, 24.5, 26.4, 28.1, 29.9, 32.1, 35.4, 38.3, 43.2] },
    { ageMin: 30, ageMax: 39, percentiles: [21.4, 26.8, 29.3, 33.4, 36.8, 40.6, 43.6, 46.8, 50.7] },
    { ageMin: 40, ageMax: 49, percentiles: [24.5, 31.4, 34.3, 37.4, 40.0, 42.6, 44.5, 48.2, 51.0] },
    { ageMin: 50, ageMax: 59, percentiles: [30.3, 34.4, 38.0, 40.5, 42.7, 45.0, 47.0, 49.3, 51.8] },
    { ageMin: 60, ageMax: 69, percentiles: [32.5, 35.5, 38.6, 40.8, 42.4, 44.9, 47.0, 49.1, 52.2] },
    { ageMin: 70, ageMax: 100, percentiles: [30.5, 35.5, 37.9, 39.6, 41.2, 43.5, 45.8, 48.2, 50.1] }
  ]
};

/**
 * Get body fat status based on age and gender
 * @param {string} gender - 'male' or 'female'
 * @param {number} age - Age in years
 * @returns {number} Status code: 0 (Under), 1 (Adequate), 2 (Over)
 */
function getBodyFatRange(gender, age, position) {
  let resRange = {start: 0.0, middle: 11.0, middle2: 31.8, end: 90};
  const ranges = bodyFatPercentiles[gender.toLowerCase()];
  if (!ranges) return resRange[position];

  const ageRange = ranges.find(r => age >= r.ageMin && age <= r.ageMax);
  if (!ageRange) return resRange[position];

  const p = ageRange.percentiles;
  resRange = {start: (p[0]-7), middle: p[0], middle2: p[5], end: (p[8]+7)};

  return resRange[position];
};

  function apSpineLogic(reportData, position, order) {
    {
      if (reportData.bmdSections?.apSpine.length === 5)
      {
        if (position === 4 && order === 0) 
          return reportData.bmdSections?.apSpine[3]?.bmd || '--' ;
        else if (position === 4 && order === 1) 
          return reportData.bmdSections?.apSpine[3]?.region || '--' ;
        else if (position === 4 && order === 2) 
          return reportData.bmdSections?.apSpine[3]?.tScore || '--' ;
        else if (position === 4 && order === 3) 
          return reportData.bmdSections?.apSpine[3]?.zScore || '--' ;
        else if (position === 5 && order === 0) 
          return reportData.bmdSections?.apSpine[4]?.bmd || '--' ;
        else if (position === 5 && order === 1) 
          return reportData.bmdSections?.apSpine[4]?.region || '--' ;
        else if (position === 5 && order === 2) 
          return reportData.bmdSections?.apSpine[4]?.tScore || '--' ;
        else if (position === 5 && order === 3) 
          return reportData.bmdSections?.apSpine[4]?.zScore || '--' ;
        else
          return '--';
      }
      else if (reportData.bmdSections?.apSpine.length === 4)
      {
        if (position === 5 && order === 0) 
          return reportData.bmdSections?.apSpine[3]?.bmd || '--' ;
        else if (position === 5 && order === 1) 
          return reportData.bmdSections?.apSpine[3]?.region || '--' ;
        else if (position === 5 && order === 2) 
          return reportData.bmdSections?.apSpine[3]?.tScore || '--' ;
        else if (position === 5 && order === 3) 
          return reportData.bmdSections?.apSpine[3]?.zScore || '--' ;
        else
          return '--';
      }
      else
        return '--';
    }
  };




    // Add split helper function to the template
    template = template.replace(/{{#split ([^}]+) "\\n"}}([^}]+){{\/split}}/g, (match, strVar, content) => {
        const str = reportData[strVar.trim()];
        const lines = splitStringIntoLines(str);
        return lines.map(line => content.replace('{{this}}', line)).join('');
    });

    const replacements = {
      '{{patient_id}}': reportData.patientId || 'N/A',
      '{{sid_no}}': reportData.reportId || 'N/A',
      '{{appointment_id}}': reportData.appointment_id || 'N/A',
      '{{name}}': reportData.name || 'N/A',
      '{{height}}': reportData.height || 'N/A',
      '{{weight}}': reportData.weight || 'N/A',
      '{{age}}': reportData.age || 'N/A',
      '{{gender}}': reportData.gender.toUpperCase().substring(0, 1) || 'N/A',
      '{{dob}}': reportData.dob ? formatDate(reportData.dob) : 'N/A',
      '{{date_of_exam}}': reportData.date_of_exam ? formatDate(reportData.date_of_exam) : 'N/A',
      '{{fat_mass}}': reportData.fat_mass ? (parseFloat(reportData.fat_mass) * 0.001).toFixed(2) : '--',
      '{{lean_mass}}': reportData.lean_mass ? (parseFloat(reportData.lean_mass) * 0.001).toFixed(2) : '--',
      '{{bmc}}': reportData.bmc ? (parseFloat(reportData.bmc) * 0.001).toFixed(2) : '--',
      '{{total_mass}}': reportData.total_mass ? (parseFloat(reportData.total_mass) * 0.001).toFixed(2) : '--',
      '{{asymmetry_status_class}}': getasymmetryStatusClass(reportData.overall_limb_asymmetry_status) || 'green',
      '{{asymmetry_status_title}}': getasymmetryStatusTitle(reportData.overall_limb_asymmetry_status) || 'green',
      '{{asymmetry_description}}': getasymmetryDescription(reportData.overall_limb_asymmetry_status) || 'green',
      '{{fat_status_class}}': getFatStatusClass(parseInt(reportData.fat_nutrition_status)) || 'green',
      '{{fat_status_risk}}': getFatStatusRisk(parseInt(reportData.fat_status)) || 'green',
      '{{fat_status_risk_status}}': getFatRiskStatus(parseInt(reportData.fat_status)) || 'green',
      '{{fat_status_title}}': getFatStatusTitle(parseInt(reportData.fat_nutrition_status)) || 'green',
      '{{fat_status_description}}': getFatStatusDescription(reportData.age,reportData.gender,parseInt(reportData.fat_nutrition_status), getBodyFatRange(reportData.gender, reportData.age, 'middle'), getBodyFatRange(reportData.gender, reportData.age, 'middle2')),
      '{{ag_radio_class}}': getAGRadioClass(parseInt(reportData.ag_ratio_status)) || 'green',
      '{{ag_radio_status_title}}': getAGRadioStatusTitle(parseInt(reportData.ag_ratio_status)) || 'green',
      '{{visceralFatStatusClass}}': getVisceralFatStatusClass(parseInt(reportData.vfa_status)) || 'green',
      '{{visceralFatStatusTitle}}': getVisceralFatStatusTitle(parseInt(reportData.vfa_status)) || 'green',
      '{{fat_status_page3_title}}': getFatStatusPage3Title(parseInt(reportData.fat_nutrition_status)) || 'green',
      '{{fat_status_page3_description}}': getFatStatusPage3Description(parseInt(reportData.fat_nutrition_status)) || 'green',
      '{{muscle_status_class}}': getMuscleStatusClass(reportData.almi_number, reportData.gender) || 'green',
      '{{muscle_status_risk_class}}': getMuscleStatusRiskClass(reportData.almi_number, reportData.gender) || 'green',
      '{{muscle_status_risk}}': getMuscleStatusRisk(reportData.almi_number, reportData.gender) || 'green',
      '{{muscle_status_message}}': getMuscleStatusMessage(reportData.almi_number, reportData.gender) || 'green',
      '{{muscle_status_description}}': getMuscleStatusDescription(reportData.almi_number, reportData.gender) || 'green',
      '{{bone_density_status_class}}': getBoneDensityStatusClass(reportData.fracture_risk) || 'yellow',
      '{{bone_density_status_risk}}': getBoneDensityStatusRisk(reportData.fracture_risk) || 'yellow',
      '{{bone_density_status_title}}': getBoneDensityStatusTitle(reportData.fracture_risk) || 'yellow',
      '{{bone_density_status_description}}': getBoneDensityStatusDescription(reportData.fracture_risk) || 'yellow',
      '{{overall_risk_factor}}': getOverallRiskFactor(
        getMuscleStatusRiskClass(reportData.almi_number, reportData.gender),
        getFatRiskStatus(parseInt(reportData.fat_status)),
        getBoneDensityStatusClass(reportData.fracture_risk)
      ) || 'green',
      '{{overall_risk_factor_title}}': getOverallRiskFactorTitle(getOverallRiskFactor(
        getMuscleStatusRiskClass(reportData.almi_number, reportData.gender),
        getFatRiskStatus(parseInt(reportData.fat_status)),
        getBoneDensityStatusClass(reportData.fracture_risk)
      )) || 'green',

      '{{body_fat_range_start}}': getBodyFatRange(reportData.gender, reportData.age, 'start') || 'green',
      '{{body_fat_range_middle}}': getBodyFatRange(reportData.gender, reportData.age, 'middle') || 'green',
      '{{body_fat_range_middle2}}': getBodyFatRange(reportData.gender, reportData.age, 'middle2') || 'green',
      '{{body_fat_range_end}}': getBodyFatRange(reportData.gender, reportData.age, 'end') || 'green',
      '{{muscle_mass}}': reportData.muscle_mass || '--',
      '{{bone_density}}': reportData.bone_density || '--',
      '{{in_range}}': 'In Range',
      '{{suboptimal}}': 'Suboptimal',
      '{{needs_attention}}': 'Needs Attention',
      // BMD SECTIONS
      '{{bmdSections_apSpine_bmd_1}}': reportData.bmdSections?.apSpine?.[0]?.bmd || '--',
      '{{bmdSections_apSpine_region_1}}': reportData.bmdSections?.apSpine?.[0]?.region || '--',
      '{{bmdSections_apSpine_tScore_1}}': reportData.bmdSections?.apSpine?.[0]?.tScore || '--',
      '{{bmdSections_apSpine_zScore_1}}': reportData.bmdSections?.apSpine?.[0]?.zScore || '--',
      //
      '{{bmdSections_apSpine_bmd_2}}': reportData.bmdSections?.apSpine?.[1]?.bmd || '--',
      '{{bmdSections_apSpine_region_2}}': reportData.bmdSections?.apSpine?.[1]?.region || '--',
      '{{bmdSections_apSpine_tScore_2}}': reportData.bmdSections?.apSpine?.[1]?.tScore || '--',
      '{{bmdSections_apSpine_zScore_2}}': reportData.bmdSections?.apSpine?.[1]?.zScore || '--',
      //
      '{{bmdSections_apSpine_bmd_3}}': reportData.bmdSections?.apSpine?.[2]?.bmd || '--',
      '{{bmdSections_apSpine_region_3}}': reportData.bmdSections?.apSpine?.[2]?.region || '--',
      '{{bmdSections_apSpine_tScore_3}}': reportData.bmdSections?.apSpine?.[2]?.tScore || '--',
      '{{bmdSections_apSpine_zScore_3}}': reportData.bmdSections?.apSpine?.[2]?.zScore || '--',
      //
      '{{bmdSections_apSpine_bmd_4}}': apSpineLogic(reportData, 4, 0),
      '{{bmdSections_apSpine_region_4}}': apSpineLogic(reportData, 4, 1),
      '{{bmdSections_apSpine_tScore_4}}': apSpineLogic(reportData, 4, 2),
      '{{bmdSections_apSpine_zScore_4}}': apSpineLogic(reportData, 4, 3),
      //
      '{{bmdSections_apSpine_bmd_total}}': apSpineLogic(reportData, 5, 0),
      '{{bmdSections_apSpine_region_total}}': apSpineLogic(reportData, 5, 1),
      '{{bmdSections_apSpine_tScore_total}}': apSpineLogic(reportData, 5, 2),
      '{{bmdSections_apSpine_zScore_total}}': apSpineLogic(reportData, 5, 3),
      //
      '{{bmdSections_leftFemur_bmd_1}}': reportData.bmdSections?.leftFemur?.[0]?.bmd || '--',
      '{{bmdSections_leftFemur_region_1}}': reportData.bmdSections?.leftFemur?.[0]?.region || '--',
      '{{bmdSections_leftFemur_tScore_1}}': reportData.bmdSections?.leftFemur?.[0]?.tScore || '--',
      '{{bmdSections_leftFemur_zScore_1}}': reportData.bmdSections?.leftFemur?.[0]?.zScore || '--',
      //
      '{{bmdSections_leftFemur_bmd_total}}': reportData.bmdSections?.leftFemur?.[1]?.bmd || '--',
      '{{bmdSections_leftFemur_region_total}}': reportData.bmdSections?.leftFemur?.[1]?.region || '--',
      '{{bmdSections_leftFemur_tScore_total}}': reportData.bmdSections?.leftFemur?.[1]?.tScore || '--',
      '{{bmdSections_leftFemur_zScore_total}}': reportData.bmdSections?.leftFemur?.[1]?.zScore || '--',
      //
      '{{bmdSections_rightFemur_bmd_1}}': reportData.bmdSections?.rightFemur?.[0]?.bmd || '--',
      '{{bmdSections_rightFemur_region_1}}': reportData.bmdSections?.rightFemur?.[0]?.region || '--',
      '{{bmdSections_rightFemur_tScore_1}}': reportData.bmdSections?.rightFemur?.[0]?.tScore || '--',
      '{{bmdSections_rightFemur_zScore_1}}': reportData.bmdSections?.rightFemur?.[0]?.zScore || '--',
      //
      '{{bmdSections_rightFemur_bmd_total}}': reportData.bmdSections?.rightFemur?.[1]?.bmd || '--',
      '{{bmdSections_rightFemur_region_total}}': reportData.bmdSections?.rightFemur?.[1]?.region || '--',
      '{{bmdSections_rightFemur_tScore_total}}': reportData.bmdSections?.rightFemur?.[1]?.tScore || '--',
      '{{bmdSections_rightFemur_zScore_total}}': reportData.bmdSections?.rightFemur?.[1]?.zScore || '--',
      //
      '{{bmdSections_apSpain_image}}': reportData.bmdImages?.apSpine || '--',
      '{{bmdSections_leftFemur_image}}': reportData.bmdImages?.leftFemur || '--',
      '{{bmdSections_rightFemur_image}}': reportData.bmdImages?.rightFemur || '--',
      //
      '{{asymmetry_ffmi}}': reportData.asymmetry?.ffmi || '--',
      '{{asymmetry_almi}}': reportData.asymmetry?.almi || '--',
      '{{asymmetry_armComposition_rightArm_fat}}': reportData.asymmetry?.limbComposition?.rightArm?.fat || '--',
      '{{asymmetry_armComposition_rightArm_lean}}': reportData.asymmetry?.limbComposition?.rightArm?.lean || '--',
      '{{asymmetry_armComposition_rightArm_bmc}}': reportData.asymmetry?.limbComposition?.rightArm?.bmc || '--',
      '{{asymmetry_armComposition_leftArm_fat}}': reportData.asymmetry?.limbComposition?.leftArm?.fat || '--',
      '{{asymmetry_armComposition_leftArm_lean}}': reportData.asymmetry?.limbComposition?.leftArm?.lean || '--',
      '{{asymmetry_armComposition_leftArm_bmc}}': reportData.asymmetry?.limbComposition?.leftArm?.bmc || '--',
      '{{asymmetry_legComposition_rightLeg_fat}}': reportData.asymmetry?.limbComposition?.rightLeg?.fat || '--',
      '{{asymmetry_legComposition_rightLeg_lean}}': reportData.asymmetry?.limbComposition?.rightLeg?.lean || '--',
      '{{asymmetry_legComposition_rightLeg_bmc}}': reportData.asymmetry?.limbComposition?.rightLeg?.bmc || '--',
      '{{asymmetry_legComposition_leftLeg_fat}}': reportData.asymmetry?.limbComposition?.leftLeg?.fat || '--',
      '{{asymmetry_legComposition_leftLeg_lean}}': reportData.asymmetry?.limbComposition?.leftLeg?.lean || '--',
      '{{asymmetry_legComposition_leftLeg_bmc}}': reportData.asymmetry?.limbComposition?.leftLeg?.bmc || '--',
      '{{asymmetry_rightArm_total}}': ((parseInt(reportData.asymmetry?.limbComposition?.rightArm?.bmc || 0) + parseInt(reportData.asymmetry?.limbComposition?.rightArm?.lean || 0) + parseInt(reportData.asymmetry?.limbComposition?.rightArm?.fat || 0)) * 0.001).toFixed(2) || '--',
      '{{asymmetry_leftArm_total}}': ((parseInt(reportData.asymmetry?.limbComposition?.leftArm?.bmc || 0) + parseInt(reportData.asymmetry?.limbComposition?.leftArm?.lean || 0) + parseInt(reportData.asymmetry?.limbComposition?.leftArm?.fat || 0)) * 0.001).toFixed(2) || '--',
      '{{asymmetry_rightLeg_total}}': ((parseInt(reportData.asymmetry?.limbComposition?.rightLeg?.bmc || 0) + parseInt(reportData.asymmetry?.limbComposition?.rightLeg?.lean || 0) + parseInt(reportData.asymmetry?.limbComposition?.rightLeg?.fat || 0)) * 0.001).toFixed(2) || '--',
      '{{asymmetry_leftLeg_total}}': ((parseInt(reportData.asymmetry?.limbComposition?.leftLeg?.bmc || 0) + parseInt(reportData.asymmetry?.limbComposition?.leftLeg?.lean || 0) + parseInt(reportData.asymmetry?.limbComposition?.leftLeg?.fat || 0)) * 0.001).toFixed(2) || '--',
      '{{asymmetry_trunk_total}}': ((parseInt(reportData.asymmetry?.limbComposition?.trunk?.bmc || 0) + parseInt(reportData.asymmetry?.limbComposition?.trunk?.lean || 0) + parseInt(reportData.asymmetry?.limbComposition?.trunk?.fat || 0)) * 0.001).toFixed(2) || '--',
      '{{asymmetry_leftArm_bone_percentage}}': (parseInt(reportData.asymmetry?.limbComposition?.leftArm?.bmc || 0) / (parseInt(reportData.asymmetry?.limbComposition?.leftArm?.bmc || 0) + parseInt(reportData.asymmetry?.limbComposition?.leftArm?.lean || 0) + parseInt(reportData.asymmetry?.limbComposition?.leftArm?.fat || 0)) * 100).toFixed(0) || '--',
      '{{asymmetry_leftArm_muscle_percentage}}': (parseInt(reportData.asymmetry?.limbComposition?.leftArm?.lean || 0) / (parseInt(reportData.asymmetry?.limbComposition?.leftArm?.bmc || 0) + parseInt(reportData.asymmetry?.limbComposition?.leftArm?.lean || 0) + parseInt(reportData.asymmetry?.limbComposition?.leftArm?.fat || 0)) * 100).toFixed(0) || '--',
      '{{asymmetry_leftArm_fat_percentage}}': (parseInt(reportData.asymmetry?.limbComposition?.leftArm?.fat || 0) / (parseInt(reportData.asymmetry?.limbComposition?.leftArm?.bmc || 0) + parseInt(reportData.asymmetry?.limbComposition?.leftArm?.lean || 0) + parseInt(reportData.asymmetry?.limbComposition?.leftArm?.fat || 0)) * 100).toFixed(2) || '--',
      '{{asymmetry_rightArm_bone_percentage}}': (parseInt(reportData.asymmetry?.limbComposition?.rightArm?.bmc || 0) / (parseInt(reportData.asymmetry?.limbComposition?.rightArm?.bmc || 0) + parseInt(reportData.asymmetry?.limbComposition?.rightArm?.lean || 0) + parseInt(reportData.asymmetry?.limbComposition?.rightArm?.fat || 0)) * 100).toFixed(0) || '--',
      '{{asymmetry_rightArm_muscle_percentage}}': (parseInt(reportData.asymmetry?.limbComposition?.rightArm?.lean || 0) / (parseInt(reportData.asymmetry?.limbComposition?.rightArm?.bmc || 0) + parseInt(reportData.asymmetry?.limbComposition?.rightArm?.lean || 0) + parseInt(reportData.asymmetry?.limbComposition?.rightArm?.fat || 0)) * 100).toFixed(0) || '--',
      '{{asymmetry_rightArm_fat_percentage}}': (parseInt(reportData.asymmetry?.limbComposition?.rightArm?.fat || 0) / (parseInt(reportData.asymmetry?.limbComposition?.rightArm?.bmc || 0) + parseInt(reportData.asymmetry?.limbComposition?.rightArm?.lean || 0) + parseInt(reportData.asymmetry?.limbComposition?.rightArm?.fat || 0)) * 100).toFixed(0) || '--',
      '{{asymmetry_rightLeg_bone_percentage}}': (parseInt(reportData.asymmetry?.limbComposition?.rightLeg?.bmc || 0) / (parseInt(reportData.asymmetry?.limbComposition?.rightLeg?.bmc || 0) + parseInt(reportData.asymmetry?.limbComposition?.rightLeg?.lean || 0) + parseInt(reportData.asymmetry?.limbComposition?.rightLeg?.fat || 0)) * 100).toFixed(0) || '--',
      '{{asymmetry_rightLeg_muscle_percentage}}': (parseInt(reportData.asymmetry?.limbComposition?.rightLeg?.lean || 0) / (parseInt(reportData.asymmetry?.limbComposition?.rightLeg?.bmc || 0) + parseInt(reportData.asymmetry?.limbComposition?.rightLeg?.lean || 0) + parseInt(reportData.asymmetry?.limbComposition?.rightLeg?.fat || 0)) * 100).toFixed(0) || '--',
      '{{asymmetry_rightLeg_fat_percentage}}': (parseInt(reportData.asymmetry?.limbComposition?.rightLeg?.fat || 0) / (parseInt(reportData.asymmetry?.limbComposition?.rightLeg?.bmc || 0) + parseInt(reportData.asymmetry?.limbComposition?.rightLeg?.lean || 0) + parseInt(reportData.asymmetry?.limbComposition?.rightLeg?.fat || 0)) * 100).toFixed(0) || '--',
      '{{asymmetry_leftLeg_bone_percentage}}': (parseInt(reportData.asymmetry?.limbComposition?.leftLeg?.bmc || 0) / (parseInt(reportData.asymmetry?.limbComposition?.leftLeg?.bmc || 0) + parseInt(reportData.asymmetry?.limbComposition?.leftLeg?.lean || 0) + parseInt(reportData.asymmetry?.limbComposition?.leftLeg?.fat || 0)) * 100).toFixed(0) || '--',
      '{{asymmetry_leftLeg_muscle_percentage}}': (parseInt(reportData.asymmetry?.limbComposition?.leftLeg?.lean || 0) / (parseInt(reportData.asymmetry?.limbComposition?.leftLeg?.bmc || 0) + parseInt(reportData.asymmetry?.limbComposition?.leftLeg?.lean || 0) + parseInt(reportData.asymmetry?.limbComposition?.leftLeg?.fat || 0)) * 100).toFixed(0) || '--',
      '{{asymmetry_leftLeg_fat_percentage}}': (parseInt(reportData.asymmetry?.limbComposition?.leftLeg?.fat || 0) / (parseInt(reportData.asymmetry?.limbComposition?.leftLeg?.bmc || 0) + parseInt(reportData.asymmetry?.limbComposition?.leftLeg?.lean || 0) + parseInt(reportData.asymmetry?.limbComposition?.leftLeg?.fat || 0)) * 100).toFixed(0) || '--',
      '{{asymmetry_trunk_bone_percentage}}': (parseInt(reportData.asymmetry?.limbComposition?.trunk?.bmc || 0) / (parseInt(reportData.asymmetry?.limbComposition?.trunk?.bmc || 0) + parseInt(reportData.asymmetry?.limbComposition?.trunk?.lean || 0) + parseInt(reportData.asymmetry?.limbComposition?.trunk?.fat || 0)) * 100).toFixed(0) || '--',
      '{{asymmetry_trunk_muscle_percentage}}': (parseInt(reportData.asymmetry?.limbComposition?.trunk?.lean || 0) / (parseInt(reportData.asymmetry?.limbComposition?.trunk?.bmc || 0) + parseInt(reportData.asymmetry?.limbComposition?.trunk?.lean || 0) + parseInt(reportData.asymmetry?.limbComposition?.trunk?.fat || 0)) * 100).toFixed(0) || '--',
      '{{asymmetry_trunk_fat_percentage}}': (parseInt(reportData.asymmetry?.limbComposition?.trunk?.fat || 0) / (parseInt(reportData.asymmetry?.limbComposition?.trunk?.bmc || 0) + parseInt(reportData.asymmetry?.limbComposition?.trunk?.lean || 0) + parseInt(reportData.asymmetry?.limbComposition?.trunk?.fat || 0)) * 100).toFixed(0) || '--',
      '{{asymmetry_image}}': reportData.asymmetry?.imageUrl || '--',
      '{{visceral_fat_area}}': reportData.visceral_fat_area || '--',
      '{{visceral_fat}}': reportData.visceral_fat || '--',
      '{{andriod_gynoid_fat}}': reportData.andriod_gynoid_fat || '--',
      '{{body_composition_trunk}}': reportData.body_composition_trunk || '--',
      '{{almi_ffmi}}': reportData.almi_ffmi || '--',
      '{{right_arm_status}}': reportData.right_arm_status || '--',
      '{{left_arm_status}}': reportData.left_arm_status || '--',
      '{{right_leg_status}}': reportData.right_leg_status || '--',
      '{{left_leg_status}}': reportData.left_leg_status || '--',
      '{{asymmetry_status}}': reportData.asymmetry_status || '--',
      '{{bmdImages_apSpine}}': reportData.bmdImages?.apSpine || '--',
      '{{bmdImages_leftFemur}}': reportData.bmdImages?.leftFemur || '--',
      '{{bmdImages_rightFemur}}': reportData.bmdImages?.rightFemur || '--',
      '{{fracture_risk}}': reportData.fracture_risk || '--',
      '{{fracture_risk_description}}': reportData.fracture_risk_description || '--',
      '{{fat_status}}': reportData.fat_status || '--',
      '{{body_fat_percentage_description}}': reportData.body_fat_percentage_description || '--',
      '{{ag_ratio}}': reportData.ag_ratio || '--',
      '{{ag_ratio_description}}': reportData.ag_ratio_description || '--',
      '{{ag_ratio_status}}': reportData.ag_ratio_status || '--',  
      '{{body_composition_zone}}': reportData.body_composition_zone || '--',
      '{{body_composition_zone_description}}': reportData.body_composition_zone_description || '--',
      '{{body_composition_zone_nutrition_suggestion}}': getNutritionSuggestions(reportData.body_composition_zone_nutrition_suggestion),
      '{{body_composition_zone_training_suggestion}}': getNutritionSuggestions(reportData.body_composition_zone_training_suggestion),
      '{{vfa_status}}': reportData.vfa_status || '--',
      '{{vfa_description}}': reportData.vfa_description || '--',
      '{{arm_asymmetry_percentage}}': reportData.arm_asymmetry_percentage || '--',
      '{{arm_right_side_increase}}': reportData.arm_right_side_increase || '--',
      '{{leg_asymmetry_percentage}}': reportData.leg_asymmetry_percentage || '--',
      '{{leg_right_side_increase}}': reportData.leg_right_side_increase || '--',
      '{{overall_limb_asymmetry_status}}': reportData.overall_limb_asymmetry_status || '--',
      '{{overall_limb_asymmetry_description}}': reportData.overall_limb_asymmetry_description || '--',
      '{{vfa_grams}}': reportData.vfa_grams || '--',
      '{{gynoid_fat}}': reportData.gynoid_fat || '--',
      '{{z_score}}': reportData.z_score || '--',
      '{{t_score}}': reportData.t_score || '--',
      '{{fat_nutrition_status}}': reportData.fat_nutrition_status || '--',
      '{{fracture_risk_status}}': reportData.fracture_risk_status || '--',
      '{{almi_number}}': parseFloat(reportData.almi_number).toFixed(2) || '--',
      '{{ffmi_number}}': parseFloat(reportData.ffmi_number).toFixed(2) || '--',
      '{{body_fat_percentage}}': Math.round(parseFloat(reportData.body_fat_percentage)) || '--',
      '{{muscle_loss_status}}': reportData.muscle_loss_status || '--',
    };

    // Replace all placeholders in the template
    Object.entries(replacements).forEach(([key, value]) => {
      template = template.replace(new RegExp(key, 'g'), value);
    });

    return template;
  } catch (error) {
    console.error('Error generating report:', error);
    throw error;
  }
};